import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="container px-4 mx-auto md:px-8 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-emerald lg:prose-xl max-w-none"
        >
          <h1 className="text-4xl font-bold text-emerald-950 mb-8 border-b pb-4">Impressum</h1>
          
          <section className="mb-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong>Horst Küppers</strong><br />
              Waldhufenstr. 9<br />
              52525 Heinsberg
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-emerald-900 mb-4">Kontakt</h2>
            <p className="text-gray-700">
              Telefon: 02452 - 9963733<br />
              Telefax: 02452 - 9963734<br />
              E-Mail: <a href="mailto:hkp@kueppers.biz" className="text-emerald-700 hover:underline">hkp@kueppers.biz</a>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-emerald-900 mb-4">Umsatzsteuer-ID</h2>
            <p className="text-gray-700">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <span className="font-mono">DE176183578</span>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-emerald-900 mb-4">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>Berufsbezeichnung:</strong> Kaufmann</p>
              <p>
                <strong>Zuständige Kammer:</strong><br />
                Handelsregisternummer: HRB 873 Aachen<br />
                Berufsgenossenschaft des BG Metallbau: M 32 35 360
              </p>
              <p><strong>Verliehen in:</strong> Deutschland</p>
            </div>
          </section>

          <section className="mb-10 p-6 bg-gray-50 border-l-4 border-emerald-900 rounded-sm">
            <h2 className="text-xl font-bold text-emerald-900 mb-3">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
            <p className="text-gray-700 italic">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
}